<template>
    <div class="socialfeed-item">
        <a v-if="feed.feed_link && feed.feed_image" :href="feed.feed_link" class="socialfeed-item__image" target="_blank">
            <img :src="feed.feed_image" alt="" width="768" loading="lazy"/>
        </a>
        <div v-else-if="feed.feed_image" class="socialfeed-item__image">
            <img :src="feed.feed_image" alt="" width="768" loading="lazy" />
        </div>
        <div class="socialfeed-item__content">
            <div class="socialfeed-item__icon">
                <i v-if="feed.feed_icon" class="fa-brands" :class="feed.feed_icon"></i>
            </div>
            <div class="socialfeed-item__text">
                <p v-html="contentText(feed.feed_content)"></p>
                <div class="socialfeed-item__info">
                    <div class="socialfeed-item__created" v-html="timeAgo(feed.feed_create_ts)"></div>
                    <div class="socialfeed-item__action">
                        <span class="socialfeed-item__actionicon" v-for="action in feed.feed_action_bar">
                            <a :href="action.src" target="_blank">
                                <span class="fal" :class="action.icon"></span>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
    name: "news-feed-item",
    props: {
        feed: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const feed = props.feed;

        const { t } = useI18n({ useScope: 'global' });

        const contentText = (text) => {
            if (text.length>160) {
                text = text.substring(0,160);
                text = text.split(" ");
                text.pop();
                text = text.join(" ")+'&hellip;';
            }
            return text;
        }

        const timeAgo = (date) => {
            const diff = Date.now() - date;

            const diffDate = new Date(diff);

            let d = diffDate.getFullYear() - 1970;
            if (d > 1) {
                return t("ago.years",{t:d});
            }
            if (d === 1) {
                return t("ago.year");
            }

            d = diffDate.getMonth() - 1;
            if (d > 1) {
                return t("ago.months",{t:d});
            }
            if (d === 1) {
                return t("ago.month");
            }

            d = diffDate.getDate() -1;
            if (d > 1) {
                if (d < 7) {
                    return t("ago.days",{t:d});
                } else {
                    if (d < 14) {
                        return t("ago.week");
                    } else {
                        return t("ago.weeks",{t:Math.floor(d / 7)});
                    }
                }
            }
            if (d === 1) {
                return t("ago.day");
            }

            d = diffDate.getHours();
            if (d > 1) {
                return t("ago.hours",{t:d});
            }
            if (d === 1) {
                return t("ago.hour");
            }

            d = diffDate.getMinutes();
            if (d > 1) {
                return t("ago.minutes",{t:d});
            }
            return t("ago.minute");
        }

        return {
            feed,
            contentText,
            timeAgo
        }
    }
}
</script>
